import { CardSectionLabel, CardSectionTextClamped } from '../styles/briefPanel.styles';

type ConceptSectionProps = {
  conceptDescription: string;
  isClamped: boolean;
};

const ConceptSection = ({ conceptDescription, isClamped }: ConceptSectionProps) => (
  <>
    <CardSectionLabel>Concept Description</CardSectionLabel>
    <CardSectionTextClamped clamped={isClamped}>{conceptDescription}</CardSectionTextClamped>
  </>
);

export default ConceptSection;
